import { Menu, MenuList, MenuProps } from '@mui/material';

export const DenseMenu = ({ children, ...props }: MenuProps) => (
  <Menu
    {...props}
    slotProps={{
      paper: {
        sx: {
          padding: 0,
          borderRadius: 2.5,
        },
      },
    }}>
    <MenuList dense disablePadding>
      {children}
    </MenuList>
  </Menu>
);
